<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="650px" style="z-index: 1019;">
      <v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
      <v-card v-if="!loading">
        <v-card-title>
          <v-panel>
              <span class="d-block" style="font-size: 20px;">
                {{ title }}
              </span>
          </v-panel>
          <v-col cols="12" class="py-0 pl-0">
              <span style="color: #616161;">
                {{ subtitle }}
              </span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols='12'>
                <TargetManager 
                  v-model="currentTypeId"
                  ref="TargetManager"
                  :types="types"
                  :filterByProfile="filterByProfile"
                  :selectedIds="selectedIds"
                  :isProject="projectId ? true : false"
                  :targetLabel="targetLabel" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.add").toUpperCase() }}
          </v-btn>
          <v-btn text @click="showDialog = false" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase()}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import TargetManager from "../../common/TargetManager.vue";

export default {
  name: "TargetManagerDialog",
  mixins: [BaseModule],
  props: ['title', 'subtitle', 'targetLabel', 'filterByProfile'],
  components: {
    TargetManager
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      projectId: null,
      selectedIds: null,
      msgCb: null,
      types: [],
      employeeIds: [],
      currentTypeId: 0
    };
  },
  methods: {
    open(selectedIds, projectId, msgCb) {
      this.currentTypeId = 0;
      this.selectedIds = selectedIds;
      this.projectId = projectId;
      this.msgCb = msgCb;
      
			this.types = [
				{ id: 0, name: this.$t('wkt.admin.employee-selector-window.target_company') },
				{ id: 1, name: this.$t('wkt.admin.employee-selector-window.target_group') },
        { id: 2, name: this.$t('wkt.admin.employee-selector-window.target_project') },
				{ id: 3, name: this.$t('wkt.admin.employee-selector-window.target_employees') },
        { id: 4, name: this.$t('wkt.admin.employee-selector-window.target_myteam') }
			];

    //   if (this.$refs.TargetManager) { // TODO: Esto no hace falta
    //   this.$refs.TargetManager.resetComponentState();
    // }
      this.showDialog = true;
    },		
    ok() {
      this.showDialog = false;
      this.$refs.TargetManager.getSelectedEmployeeIds( (employeeIds) => {
        if (employeeIds.length > 0 && this.msgCb) {
          this.msgCb(employeeIds);
        }
      });
    }
  },
};
</script>
